document.addEventListener('DOMContentLoaded', function() {
    tippy('[data-tippy-content]', {
        placement: 'top',
        arrow: true,
        animation: 'fade'
    });

    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
        const specScript = document.createElement('script');
        specScript.type = 'speculationrules';
        const specRules = {
            prerender: [{
                where: {
                    selector_matches: '.prerender'
                },
                eagerness: 'moderate'
            }]
        };
        specScript.textContent = JSON.stringify(specRules);
        document.body.append(specScript);
    }
});

